module.exports = __webpack_public_path__ + "static/media/bananella-insta.d67580db.png";